exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"Colors.css","sourceRoot":""}]);

// exports
exports.locals = {
	"ixt-blue-50": "#e3f1fc",
	"ixt-blue-100": "#c2d8ea",
	"ixt-blue-300": "#80a8c6",
	"ixt-blue-500": "#3f7397",
	"ixt-blue-600": "#205779",
	"ixt-blue-700": "#003B5C",
	"ixt-blue-800": "#00304d",
	"ixt-blue-900": "#00263e",
	"ixt-lightblue": "#3f7397",
	"ixt-blue": "#003B5C",
	"ixt-navy": "#00263e",
	"ixt-red-400": "#FF5555",
	"ixt-red": "#FF5555",
	"ixt-green-300": "#5ece84",
	"ixt-green-400": "#2fbf62",
	"ixt-green": "#2fbf62",
	"ixt-yellow-300": "#ffe055",
	"ixt-yellow-400": "#ffd82a",
	"ixt-yellow": "#ffd82a"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"minimize":true,"sourceMap":true}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/Colors.css
// module id = 74
// module chunks = 2